import { useQuery } from '@apollo/client';
import { GET_LATEST_PICKUP_ROUTE_HISTORY } from '../graphql/queries/getLatestPickupRouteHistory';
import { PickupRouteHistoryType } from '../graphql/types/PickupRouteHistoryTypes';

interface LatestPickupRouteHistoryResponse {
  getLatestPickupRouteHistory: PickupRouteHistoryType[];
}

export const useLatestPickupRouteHistory = (warehouseId?: number, pickupDate?: string, pollIntervalMs?: number) => {
  const skip = !warehouseId || !pickupDate;
  const { data, loading, error, refetch, startPolling, stopPolling } = useQuery<LatestPickupRouteHistoryResponse>(
    GET_LATEST_PICKUP_ROUTE_HISTORY,
    {
      variables: { warehouseId, pickupDate },
      skip,
      pollInterval: pollIntervalMs,
      fetchPolicy: 'network-only',
    }
  );

  return {
    histories: data?.getLatestPickupRouteHistory ?? [],
    loading,
    error,
    refetch,
    startPolling,
    stopPolling,
  };
};


